import { db } from "./firebase";
import { collection, getDocs, doc, setDoc, query, where, serverTimestamp } from "firebase/firestore";

export async function getAllCustomers() {
  const q    = query(collection(db, "users"), where("role", "==", "customer"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ uid: d.id, ...d.data() }));
}

export async function setUserProfile(uid, data) {
  await setDoc(doc(db, "users", uid), { ...data, createdAt: serverTimestamp() }, { merge: true });
}
